import { DocumentationLogic, useStyles } from './documentation.module';
import { Grid, Typography, Box } from '@material-ui/core';
import FullScreenDialog from '../Dialog/FullScreenDialog';
import LockIcon from '@material-ui/icons/Lock';
import AlertMessage from '../shared/alert/alert';

export default function Documentation(props) {
  const classes = useStyles();
  const { values } = props;
  const {
    translator,
    checkOpenNewTab,
    openDialog,
    setOpenDialog,
    children,
    requestPermission,
    permissions,
  } = DocumentationLogic({ project: values.project });

  return (
    <>
      {openDialog && (
        <FullScreenDialog
          openFromParent={openDialog}
          setOpenFromParent={setOpenDialog}
          children={children}
          title={''}
          message={''}
        />
      )}

      <Grid
        container
        justifyContent="center"
        className={classes.containerDocumentation}
      >
        <Grid item xs={12}>
          <Typography variant="h4" className={classes.documentationTitle}>
            {translator('projectDetail.documentation')}
          </Typography>
        </Grid>

        <Grid item xs={12} md={10} className={classes.contentWrapper}>
          <Box mt={5}>
            {values.project.ipfs?.length === 0 && (
              <Typography className={classes.infoText}>
                {
                  'Project, baseline and dMRV information will be available soon'
                }
              </Typography>
            )}
            {values.project.ipfs?.map((item, index) => (
              <Box
                key={index}
                className={classes.documentationSectionContainer}
              >
                <Box
                  className={classes.textArrowContainer}
                  onClick={() => checkOpenNewTab(item)}
                >
                  <Typography className={classes.documentationSectionTitle}>
                    {item.name}
                  </Typography>
                  {permissions &&
                    (permissions[item.type] ? (
                      <span className={classes.arrow}>&#8594;</span>
                    ) : (
                      <LockIcon className={classes.lockIcon} />
                    ))}
                  {requestPermission[item.type] && (
                    <AlertMessage
                      text={'Permission required'}
                      type={'success'}
                    />
                  )}
                </Box>
                <Typography className={classes.documentationSectionText}>
                  {item.description}
                </Typography>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
